angular.module('gym.waivers').factory('WaiverMerges', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('waivers').all('merges');
}]);
